import React from 'react';

import { redWaglLogo } from '../../../assets/images/';
import Button from '../../../components/Button';
import { navigateTo } from '../../../contrib/Utils/navigateTo';

const StaffStart = () => (
  <div className="start-screen wrapper">
    <div className="top">
      <h1>WELCOME TO STAFF SECTION</h1>
      <img src={redWaglLogo} className="logo" alt="logo" />
    </div>
    <div className="bottom">
      <Button
        id="login"
        onClick={navigateTo('/staff/login')}
        variant="contained"
        color="primary"
        className="login-button"
      >
        LOGIN
      </Button>
      <Button
        id="invitation"
        onClick={navigateTo('/staff/club/create/account')}
        variant="outlined"
        color="primary"
        className="login-button"
      >
        REGISTER
      </Button>
    </div>
  </div>
);

export { StaffStart };
